<template>
    <div>
        <div class="table-container">
            <!-- хлебные крошки-->
            <div class="filter-breadcrumb">
                <span class="item-breadcrumb" v-if="period === 0" >{{ 'Дата' }} - {{ dateTo}}</span>
                <span class="item-breadcrumb" v-if="reg !== null && reg_name !== null" >{{ reg }} - {{ reg_name }}</span>
            </div>
        </div>
        <div class="table-container">
            <b-table
                :fields="tableFields"
                :items="unReport"
                responsive="true"
                bordered
                head-variant="light"
                no-border-collapse
                sticky-header="true">

                <template #cell(num)="data">
                    <div v-if="!data.item._rowVariant">
                        {{ data.index + 1 }}
                    </div>
                </template>
                <template #cell(ksn)="data">
                    <div>
                        {{ $n(data.item.ksn) }}
                    </div>
                </template>

            </b-table>
        </div>
        <div class="actions-tab in-tab">
            <b-dropdown variant="link" right toggle-class="text-decoration-none" no-caret>
                <template #button-content >
                    <div class="btn-download">
                        <div>
                                        <span class="left">
                                            <i class="icon icon-download"></i> Скачать
                                        </span>
                            <i class="icon icon-keyboard"></i>
                        </div>
                    </div>
                </template>
                <b-dropdown-item v-if="unReport.length > 0" @click="downloadRep()">{{repName}}</b-dropdown-item>
            </b-dropdown>
        </div>
        <div>
            <loading
                :active="loading"
                is-full-screen
                spinner="bar-fade-scale"
                color="#6495ED"
            />
        </div>
    </div>
</template>

<script>
import {Ax} from '@/utils';
import moment from 'moment';
import VueElementLoading from "vue-element-loading";
export default {
    name: 'report-control',
    components: {'loading': VueElementLoading},
    data() {
        return {
            reg: null,
            year: 2023,
            dateTo: null,
            month: null,
            curParams: {},
            period: null,
            repCode: 'control',
            repName: 'Остаток на контрольных счетах наличности',
            overReport: [],
            unReport: [],
            loading: false,
            convert: '',
            hasData: false,
            tableFields: [
                {
                    key: 'num',
                    label: '№'
                },
                {
                    key: 'name_ru',
                    label: 'Наименование районов и городов'
                },
                {
                    key: 'ksn',
                    label: 'КСН'
                }
            ]
        }
    },
    created() {
        this.$on('report-control', (reg, reg_name, period, date_to, month, year, obl, convert) => {
            this.reportOpen(reg, period, date_to, month, year, obl, convert);
            this.reg = reg;
            this.year = year;
            this.period = period
            this.month = month;
            this.reg_name = reg_name;
            this.dateTo = moment(date_to).format('YYYY-MM-DD');
            this.convert = convert;
            // this.tableFields[2].label = `План на ${year} год`;
        });
    },
    methods: {
        async reportOpen(reg, period, date_to, month, year, obl, convert) {
            this.loading = true;
            const utcTimestamp = date_to;
            const utcDate = new Date(utcTimestamp);
            utcDate.setDate(utcDate.getDate() + 1);
            const newUtcTimestamp = utcDate.toISOString();
            this.curParams = {
                region: reg,
                period: period,
                date_to: newUtcTimestamp,
                month: month,
                year: year,
                report_id: this.report_id,
                form: this.repCode,
                obl: obl,
                user_id: this.$store.getters.user_uuid,
                convert: convert
            };
            if (reg && period > -1 && date_to && year && obl) {
                Ax(
                    {
                        url: `/api-py/get-fulldata-control/` + JSON.stringify(this.curParams),
                        method: 'GET'
                    },
                    (data) => {
                        this.unReport = data.unReport;
                        this.overReport = data.overReport;
                        this.unReport.sort((a, b) => a.region - b.region)
                        for (const d of this.unReport) {
                            if (d.ksn > 0) {
                                this.hasData = true;
                                break;
                            }
                        }
                        if ((this.unReport.length === 0 && this.overReport.length === 0) || !this.hasData) {
                            this.makeToast('info', 'Внимание', 'Данных по таким параметрам нет.');
                        }
                        if (reg.includes('0000')) {
                            this.totalRows();
                        }
                        this.loading = false;
                        this.curTab = 0;
                        this.hasData = false;
                    },
                    (error) => {
                        this.makeToast('danger', 'Ошибка запроса', error.toString());
                        this.loading = false;
                    }
                )
            } else {
                this.makeToast('info', 'Внимание', 'Не все параметры выбраны.');
                this.loading = false;
            }
        },
        makeToast(variant, title, tostbody) {
            this.$bvToast.toast(tostbody, {
                title: title,
                variant: variant,
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
                appendToast: true
            });
        },
        totalRows() {
            let regTotalKsn = 0;

            let oblTotalKsn = 0;

            for (const item of this.unReport) {
                if (!item.region.includes('0101')) {
                    regTotalKsn += item.ksn;
                } else {
                    oblTotalKsn += item.ksn;
                }
            }
            this.unReport.shift();
            this.unReport.sort((a, b) => a.name_ru.localeCompare(b.name_ru));
            this.unReport.push({
                name_ru: 'Итого по районам и городам',
                ksn: regTotalKsn,
                _rowVariant: 'info'                       
            });
            this.unReport.push({
                name_ru: 'Областной бюджет',
                ksn: oblTotalKsn,
                _rowVariant: 'warning'                       
            });
            this.unReport.push({
                name_ru: 'Бюджет области',
                ksn: regTotalKsn + oblTotalKsn,
                _rowVariant: 'primary'                       
            });
        },
        downloadRep() {
            try {
                this.makeToast('info', 'Внимание!', 'Скоро начнется скачивание. Пожалуйста ожидайте.');
                this.loading = true;
                Ax(
                    {
                        url: '/api-py/fulfill_report_control/' + JSON.stringify(this.curParams),
                        method: 'POST',
                        responseType: 'blob'
                    },
                    (data) => {
                        const url = window.URL.createObjectURL(new Blob([data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', this.repName + '.xlsx');
                        document.body.appendChild(link);
                        link.click();
                        this.loading = false;
                    },
                    (error) => {
                        this.makeToast('danger', 'Ошибка запроса downloadRep()', error.toString());
                        this.loading = false;
                    }
                );
            } catch (error) {
                console.log(error)
                this.makeToast('danger', 'Предупреждение', 'Необходимо заполнить все обязательные фильтры!');
                this.loading = false;
            } finally {
            }
        },
    }
}
</script>

<style>

</style>